import React, { useState, useEffect, useCallback } from "react";

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from "../../../firebase";
// import { db } from "../../firebase";

// import EventAddress from "../../../assets/formInputComponents/EventAddress";
// import EventDate from "../../../assets/formInputComponents/EventDate";
// import EventTime from "../../../assets/formInputComponents/EventTime";
// import EventDetails from "../../../assets/formInputComponents/EventDetails";
// import EventPerson from "../../../assets/formInputComponents/EventPerson";
// import ContactPerson from "../../../assets/formInputComponents/ContactPerson";
// import ContactEmail from "../../../assets/formInputComponents/ContactEmail";
// import ContactNumber from "../../../assets/formInputComponents/ContactNumber";
// import StudioShootDetails from "../../../assets/formInputComponents/StudioShootDetails";
// import ShootFlexibility from "../../../assets/formInputComponents/ShootFlexibility";
// import logo from "../../../assets/logo.png";

// import EventAddress from "../../assets/formInputComponents/EventAddress";
// import EventDate from "../../assets/formInputComponents/EventDate";
// import EventTime from "../../assets/formInputComponents/EventTime";
// import EventDetails from "../../assets/formInputComponents/EventDetails";
// import ContactPerson from "../../assets/formInputComponents/ContactPerson";
// import ContactEmail from "../../assets/formInputComponents/ContactEmail";
// import ContactNumber from "../../assets/formInputComponents/ContactNumber";
// import StudioShootDetails from "../../assets/formInputComponents/StudioShootDetails";
// import ShootFlexibility from "../../assets/formInputComponents/ShootFlexibility";
// import logo from "../../assets/logo.png";

export default function Price({ packageShow, packageDocReady, profile }) {
  // const [open, setOpen] = useState(false);
  // const handleOpen = () => setOpen(!open);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState([]);
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState(false);
  const [region, setRegion] = useState("");
  const hostname = window.location.hostname;

  useEffect(() => {
    if (formData.address) {
      setAddress(formData.address);
      setRegion(formData.region);
    }
  }, [formData]);

  useEffect(() => {
    if (address && region === "") {
      setAddressError(true);
    } else {
      setAddressError(false);
    }
  }, [address, region]);

  const addData = useCallback(
    (id, data) => {
      if (hostname === "localhost") {
        console.log("Local onChange: ", id, data);
      }

      setFormData((prevValue) => {
        return {
          ...prevValue,
          [id]: data,
        };
      });
    },
    [hostname]
  );

  const closeModal = () => {
    setShow(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (hostname === "localhost") {
      console.log("Submission Data: ", formData);
    }

    const docRef = collection(db, "packageBooking");

    try {
      setIsLoading(true);
      await addDoc(docRef, {
        ...formData,
        submittedAt: serverTimestamp(),
        completed: false,
        professional: profile.name,
        user: profile.user,
        status: "just submitted",
        package: packageShow,
      });
      toast.success("Your form has been submitted, we will be in touch.");
      setFormData([]);
      setIsLoading(false);
      // document.getElementById("form").reset();
      setShow(false);
      // console.log("After Submit: ", formData);
    } catch (error) {
      setIsLoading(true);
      console.log(error.message);
      toast.error(
        "Something went wrong with your submission, please try again"
      );
    }
  };

  return (
    <>
      {packageDocReady && (
        <div className="sticky left-0 bottom-0 w-full bg-white flex justify-center">
          <button
            onClick={() => setShow(true)}
            variant="gradient"
            color="orange"
            data-cy="package-price-button"
            className="w-full rounded-sm shadow-md md:w-1/6 my-1 text-white text-lg bg-orange-400 hover:bg-orange-500 active:bg-orange-600 p-2 transition-all ease-in-out delay-75"
          >
            {/* R<span data-cy="package-price-value">{packageShow.price}</span> */}
            {Number(packageShow.price).toLocaleString("en-ZA", {
              style: "currency",
              currency: "ZAR",
              minimumFractionDigits: 0,
            })}
          </button>
        </div>
      )}
    </>
  );
}
